export default __webpack_public_path__ + "static/media/condomob-logo-rounded.0d1feaea.png";